import store from '@/store'
let i18nText = {
    zh: {
        czyh: '储值优惠',
        ljyy: '立即预约',
        confirm: '确定',
        draw: '立即抽奖',
        getchance: '获取次数',
        chance: '抽奖次数',
        drawrule: '抽奖规则',
        drawrecord: '抽奖记录',
        invite1: '邀请1个好友',
        invite2: '邀请2个好友',
        invite3: '邀请3个好友',
        members: '团队人数',
        rewards: '奖励记录',
        eventRules: '活动规则',
        inviteFriends: '邀请好友',
        joinTeam: '加入团队',
        enterTeamCode: '请输入组队邀请码',
        joinNow: '即刻加入',
        copyInfo: '复制邀请信息',
        registered: '已预约人数',
        facebook: '关注Facebook',
        youtube: '关注YouTube',
        discord: '关注Discord',
        sharefriend: '分享好友',
        follow: '前往关注',
        share: '分享好友',
        name: '姓名',
        enterName: '请输入收件人姓名',
        email: '邮箱',
        enterEmail: '请输入邮箱',
        phone: '手机',
        enterPhone: '请输入联系方式',
        address: '地址',
        enterAddress: '请输入收件地址',
        submit: '提交',
        agree1: '我同意Chuang Games通过电子邮件寄送《Cross Gate: Adventure》最新游戏资讯',
        agree2_1: '我已阅读并同意Chuang Games的',
        agree2_2: '《服务条款》',
        agree2_3: '和',
        agree2_4: '《隐私协议》',
        agree2_5: '',
        booking_title: '我们将通过信箱通知您第一手游戏信息及活动资讯',
        termsOfService: '服务条款',
        privacyPolicy: '隐私政策',
        notice: '公告',
        news: '新闻',
        guides: '攻略',
        return: '返回首页',
        agreefirst: '请先勾选同意',
        nodraws: '抽奖次数不足',
        validemail: '请输入正确的电子邮箱地址',
        validphone: '请输入正确的手机号码',
        copysuccess: '复制成功',
        logout: '注销',
        copytxt: '即刻集结，领限定奖励：',
        rule: `
        <p>活动规则</p>
        <p>一、活动时间</p>
        <p>即日起至《Cross Gate: Adventure》上市前一天23:59为止，具体时间请留意官方活动公告。</p>
        <p></p>
        <p>二、参与对象</p>
        <p>所有在活动期间内，完成游戏邮箱预注册的用户均可参与。</p>
        <p></p>
        <p>三、活动流程</p>
        <p>邀请好友流程（邀请人）</p>
        <p>(1) 访问活动页：点击首页“邀请”按钮；未登录时需先通过指定关联账号登录。</p>
        <p>(2) 复制邀请信息：点击“复制邀请信息”按钮，获取专属邀请链接及团队码。</p>
        <p>(3) 分享给好友：通过社交渠道分享链接/团队码。</p>
        <p>加入团队流程（被邀请人）</p>
        <p>(1) 点击邀请链接：打开邀请人分享的链接，进入预约页面。</p>
        <p>(2) 加入团队：点击“加入”按钮完成组队，并可在奖励记录中查询相关CDK。</p>
        <p></p>
        <p>四、奖励规则</p>
        <p>邀请1位好友，全队赠送魔币*50000；</p>
        <p>邀请2位好友，全队赠送魔币*100000；</p>
        <p>邀请3位好友，全队赠送魔币*200000。</p>
        <p>奖励发放：奖励将以兑换码形式出现在“奖励记录”中，请在游戏上线后30天内兑换。</p>
        <p></p>
        <p>五、注意事项</p>
        <p>邀请上限：每位用户最多可邀请3位好友。</p>
        <p>团队码唯一：重复输入同一团队码仅计1次。</p>
        <p>隐私合规：双方须同意平台隐私及邮件协议。</p>
        <p>技术问题：登录或复制失败时，请刷新或更换网络后重试。</p>
        `,
        rule2: `
        <p>1. 预注册活动时间：即日起至《Cross Gate:Adventure》上市前一天23:59为止，具体时间请留意官方活动公告。</p>
        <p>2. 每个真实邮箱仅限一次预约机会。活动期间内完成预注册活动的玩家，方可参与其他预注册相关活动。</p>
        <p>3. 当预约人数达到里程碑目标时，对应实物奖励将于公测后全服发放。</p>
        <p>4. 活动期间内，完成预注册里程碑目标、团队集结里程碑目标，对应虚拟奖励将于游戏上市后30天内通过游戏内邮件形式发放至使用“预约账号”登录的游戏账号内。</p>
        <p>5. 活动期间内，通过抽奖活动获得的虚拟道具奖励，将以兑换码形式出现在“奖励记录”中，请在游戏正式上线后30天内前往游戏中兑换。请妥善保管好您的兑换码，兑换码仅限本人使用，如因个人原因导致无法正确兑换奖励，需自行承担。</p>
        <p> 6. 活动期间内，通过抽奖活动获得的实物奖励，请在预注册活动结束前完成收件信息填写。实物奖励寄送前，官方将通过邮件或电话确认收件人及寄送信息。如因信息未及时或正确填写导致无法寄送，视为放弃奖励资格。实物奖励将于预注册活动结束后90天内寄出。</p>
        <p>7. 所有获得的奖品不可转让、折现或兑换其他等值商品；如玩家拒绝领取，则视为放弃资格。</p>
        <p>8. 如有不正当手段参与预注册活动并获奖励者，一经核实，官方将取消其中奖资格。</p>
        <p>9. 单个账号在预注册活动页内获得的奖品兑换码使用次数上限为9次。</p>
        <p>10. 本公司保留对本页所有预注册活动的最终解释权。</p>
        `,
        congratulations: `恭喜您获得奖励，相关奖品礼包码请在“抽奖记录”中查看，请于公测后1个月内登录游戏兑换`,
        job: '职业',
        account: '账号',
        password: '密码',
        error_account_or_password: '账号/密码错误',
        unfind: '未查询到信息框',
        close: '关闭',
        contactSupport: '联系客服',
        agree3: `我同意“本活动获取并存储的游戏区服和角色相关信息，仅用于该活动的抽奖、领取、发奖、通知等操作”`,
        selectServer: '请选择服务器',
        confirmCharacter: '请确认角色',
        cancel: '取消',
        currentRole: '当前参与返利角色：',
        totalRecharge: '该账号测试期间充值总额：',
        rebate: '可获得返利总额：',
        rebateRule: '返利规则：',
        isThisRole: '请确认是否以当前选定角色领取返利？',
        receiveSuccess: '奖励已通过邮件发放至角色邮箱中，邮件有效期30天，请尽快登录并领取奖励',
        rebate_rule1: `
        <p>活动规则</p>
        <p>1. 充值返还规则</p>
        <p>①玩家在测试期间的总金额，将按照以下表格提示的规则进行倍率返还</p>
        `,
        rebate_rule2: `
        <p>例：玩家在测试期间累计充值1000美元用于购买游戏内商品，公测时可获得返利：300*1.1+500*1.05+200*1=330+525+200=1055</p>
        <p>2. 适用对象</p>
        <p>①适用对象： 所有参与本次删档付费测试并进行充值，并且用参与付费测的账号完成公测创角的玩家。</p>
        <p>②适用服务器： 本次测试的所有服务器。</p>
        <p>备注： 本次计费删档测试仅谷歌平台参与，公测后谷歌与iOS端数据互通。首次创角使用的平台不影响返利获取</p>
        <p>3. 领取方式</p>
        <p>①参与活动后，充值返利将以游戏内邮件的形式发放给对应角色。玩家开启邮箱功能后，即可收到充值返还邮件。</p>
        <p>4. 领取时间</p>
        <p>①活动开启时间： 公测服务器正式开服后。</p>
        <p>②活动截止时间： 自公测开服日起的90个自然日内。</p>
        <p>③邮件有效期： 玩家领取邮件后，返利邮件将在邮箱中存在30天，请及时领取附件。逾期未领取，将视为自动放弃，无法补发。</p>
        <p>5. 注意事项</p>
        <p>①测试充值账号下存在不同服务器下的多个角色时，则汇总多角色付费总额进行计算</p>
        <p>②返利计入范围： 仅统计通过游戏内商城、充值中心等直接付费项的金额。</p>
        <p>③返利不计入范围： 游戏内任何免费赠送、活动奖励、运营补偿、任务获得、首充双倍赠送部分、购买礼包直接获得的道具等，均不纳入累计充值金额的计算。</p>
        <p>④返利资格与测试充值账号严格绑定，不支持任何形式的跨账号/不同账号领取。</p>
        <p>⑤公测时，同一账号下若创建多个角色，返利仅发放至用户选择的角色的邮箱中，其他角色无法重复领取。</p>
        <p>⑥返还的代金券可用于游戏内所有直购项目，具体使用规则以公测版本内道具说明为准。</p>
        `
    },
    tw: {
        czyh: '儲值優惠',
        ljyy: '立即預約',
        confirm: '確定',
        draw: '立即抽獎',
        getchance: '獲取次數',
        chance: '抽獎次數',
        drawrule: '抽獎規則',
        drawrecord: '抽獎記錄',
        invite1: '邀請1個好友',
        invite2: '邀請2個好友',
        invite3: '邀請3個好友',
        members: '團隊人數',
        rewards: '獎勵記錄',
        eventRules: '活動規則',
        inviteFriends: '邀請好友',
        joinTeam: '加入團隊',
        enterTeamCode: '請輸入組隊邀請碼',
        joinNow: '即刻加入',
        copyInfo: '複製邀請資訊',
        registered: '已預約人數',
        facebook: '關注Facebook',
        youtube: '關注哈拉版',
        discord: '關注Discord',
        sharefriend: '分享好友',
        follow: '前往關注',
        share: '分享好友',
        name: '姓名',
        enterName: '請輸入收件人姓名',
        email: '郵箱',
        enterEmail: '請輸入郵箱',
        phone: '手機',
        enterPhone: '請輸入聯繫方式',
        address: '地址',
        enterAddress: '請輸入收件地址',
        submit: '提交',
        agree1: '我同意Chuang Games通過電子郵件發送《魔力寶貝：重返法蘭》的最新遊戲資訊',
        agree2_1: '我已閱讀並同意Chuang Games的',
        agree2_2: '《服務條款》',
        agree2_3: '和',
        agree2_4: '《隱私協議》',
        agree2_5: '',
        booking_title: '我們將通過信箱通知您第一手遊戲信息及活動資訊',
        termsOfService: '服務條款',
        privacyPolicy: '隱私協議',
        notice: '公告',
        news: '新聞',
        guides: '攻略',
        return: '返回首頁',
        agreefirst: '請先勾選同意',
        nodraws: '抽獎次數不足',
        validemail: '請輸入正確的電子郵箱地址',
        validphone: '請輸入正確的手機號',
        copysuccess: '複製成功',
        logout: '退出登錄',
        copytxt: '即刻集結，領限定獎勵：',
        rule: `
        <p>活動規則</p>
        <p>一、活動時間</p>
        <p> 即日起至《魔力寶貝：重返法蘭》上市前一天23:59為止，具體時間請留意官方活動公告。</p>
        <p></p>
        <p>二、參與對象</p>
        <p> 所有在活動期間內，完成遊戲郵箱預註冊的用戶均可參與。</p>
        <p></p>
        <p>三、活動流程</p>
        <p> 邀請好友流程（邀請人）</p>
        <p> (1) 訪問活動頁：點擊首頁“邀請”按鈕；未登錄時需先通過指定關聯帳號登錄。</p>
        <p> (2) 複製邀請信息：點擊“複製邀請信息”按鈕，獲取專屬邀請鏈接及團隊碼。</p>
        <p> (3) 分享給好友：通過社交渠道分享鏈接/團隊碼。</p>
        <p>加入團隊流程（被邀請人）</p>
        <p> (1) 點擊邀請鏈接：打開邀請人分享的鏈接，進入預約頁面。</p>
        <p> (2) 加入團隊：點擊“加入”按鈕完成組隊，並可在獎勵記錄中查詢相關CDK。</p>
        <p></p>
        <p>四、獎勵規則</p>
        <p> 邀請1位好友，全隊贈送魔幣*50000；</p>
        <p> 邀請2位好友，全隊贈送魔幣*100000；</p>
        <p> 邀請3位好友，全隊贈送魔幣*200000。</p>
        <p> 獎勵發放：獎勵將以兌換碼形式出現在“獎勵記錄”中，請在遊戲上線後30天內兌換。</p>
        <p></p>
        <p>五、注意事項</p>
        <p> 邀請上限：每位用戶最多可邀請3位好友。</p>
        <p> 團隊碼唯一：重複輸入同一團隊碼僅計1次。</p>
        <p> 隱私合規：雙方須同意平台隱私及郵件協議。</p>
        <p> 技術問題：登錄或複製失敗時，請刷新或更換網絡後重試。</p>
        `,
        rule2: `
        <p>1.預註冊活動時間：即日起至《魔力寶貝：重返法蘭》上市前一天23:59為止，具體時間請留意官方活動公告。</p>
        <p>2.每個真實郵箱僅限一次預約機會。活動期間內完成預註冊活動的玩家，方可參與其他預註冊相關活動。</p>
        <p>3.當預約人數達到里程碑目標時，對應實物獎勵將於公測後全服發放。</p>
        <p>4.活動期間內，完成預註冊里程碑目標、團隊集結里程碑目標，對應虛擬獎勵將於遊戲上市後30天內通過遊戲內郵件形式發放至使用「預約賬號」登入的遊戲賬號內。</p>
        <p>5.活動期間內，通過抽獎活動獲得的虛擬道具獎勵，將以兌換碼形式出現在「獎勵記錄」中，請在遊戲正式上線後30天內前往遊戲中兌換。請妥善保管好您的兌換碼，兌換碼僅限本人使用，如因個人原因導致無法正確兌換獎勵，需自行承擔。</p>
        <p>6.活動期間內，通過抽獎活動獲得的實物獎勵，請在預註冊活動結束前完成收件信息填寫。實物獎勵寄送前，官方將通過郵件或電話確認收件人及寄送信息。如因信息未及時或正確填寫導致無法寄送，視為放棄獎勵資格。實物獎勵將於預註冊活動結束後90天內寄出。</p>
        <p>7.所有獲得的獎品不可轉讓、折現或兌換其他等值商品；如玩家拒絕領取，則視為放棄資格。</p>
        <p>8.如有不正當手段參與預註冊活動並獲獎勵者，一經核實，官方將取消其中獎資格。</p>
        <p>9.單個賬號在預註冊活動頁內獲得的獎品兌換碼使用次數上限為9次。</p>
        <p>10.本公司保留對本頁所有預註冊活動的最終解釋權。</p>
        `,
        congratulations: `恭喜您獲得獎勵，相關獎品禮包碼請在「抽獎記錄」中查看，請於公測後1個月內登入遊戲兌換`,
        job: '職業',
        account: '賬號',
        password: '密碼',
        error_account_or_password: '賬號/密碼錯誤',
        unfind: '未查詢到儲值信息',
        close: '關閉',
        contactSupport: '聯係客服',
        agree3: `我同意"本活動取得並儲存的遊戲伺服器與角色相關資訊，僅用於本活動之抽獎、領取、發獎、通知等操作"`,
        selectServer: '請選擇伺服器',
        confirmCharacter: '請確認角色',
        cancel: '取消',
        currentRole: '當前參與返利的角色：',
        totalRecharge: '該帳號測試期間儲值總額：',
        rebate: '可獲得返利總額：',
        rebateRule: '返利規則：',
        isThisRole: '請確認是否以當前選定角色領取返利？',
        receiveSuccess: '獎勵已透過郵件發放至角色信箱，郵件有效期為 30 天，請儘快登入並領取獎勵。',
        rebate_rule1: `
        <p>活動規則</p>
        <p>1. 充值返還規則</p>
        <p>①玩家在測試期間的總金額，將按照以下提示的規則進行倍率返還</p>
        `,
        rebate_rule2: `
        <p>例：玩家在測試期間累計充值1000美元用於購買遊戲內商品，公測時可獲得返利：300*1.1+500*1.05+200*1=330+525+200=1055</p>
        <p>2. 適用對象</p>
        <p>①適用對象： 所有參與了先鋒測試並進行充值，並且用參與付費測的帳號完成公測創角的玩家。</p>
        <p>②適用伺服器： 所有正式伺服器。</p>
        <p>備註： 首次創角使用的平臺不影響返利獲取</p>
        <p>3. 領取方式</p>
        <p>① 下載遊戲，使用參與先鋒測試時相同的第三方帳號或 ChuangGames 帳號登入遊戲並完成角色創建。</p>
        <p>② 進入遊戲官方網站：https://cga.chuang-games.com/</p>
        <p>③ 點擊官網右下角【官方儲值返利查詢】入口。</p>
        <p>④ 登入對應的第三方帳號或 ChuangGames 帳號。</p>
        <p>⑤ 選擇您要領取返利道具的伺服器與角色，並點擊確認。</p>
        <p>⑥ 確認當前登入帳號的返利金額與返利規則無誤後，進行下一步操作，即可在遊戲內領取充值返利獎勵。</p>
        <p>⑦ 充值返利將以遊戲內郵件形式發放，角色開啟郵箱功能後即可查收。</p>
        <p>4. 領取時間</p>
        <p>①活動開啟時間： 公測伺服器正式開服後。 </p>
        <p>②活動截止時間： 自公測起的90個自然日內。 </p>
        <p>③郵件有效期： 玩家領取郵件後，返利郵件將在郵箱中存在30天，請及時領取附件。逾期未領取，將視為自動放棄，無法補發。</p>
        <p>5. 注意事項</p>
        <p>①測試充值帳號下存在不同伺服器下的多個角色時，則匯總多角色付費總額進行計算 </p>
        <p>②返利計入範圍： 僅統計通過遊戲內商城、充值中心等直接付費項的金額。</p>
        <p>③返利不計入範圍： 遊戲內任何免費贈送、活動獎勵、運營補償、任務獲得、首充雙倍贈送部分、購買禮包直接獲得的道具等，均不納入累計充值金額的計算。</p>
        <p>④返利資格與測試充值帳號嚴格綁定，不支持任何形式的跨帳號/不同帳號領取。</p>
        <p>⑤公測時，同一帳號下若創建多個角色，返利僅發放至用戶選擇的角色的郵箱中，其他角色無法重複領取。</p>
        <p>⑥返還的代金券可用於遊戲內所有直購專案，具體使用規則以公測版本內道具說明為准。</p>
        `
    },
    en: {
        ljyy: 'PRE-REGISTER',
        confirm: 'CONFIRM',
        draw: 'Lottery',
        getchance: 'GET ATTEMPTS',
        chance: 'Number of Draws',
        drawrule: 'Drawing Rules',
        drawrecord: 'Lottery Records',
        invite1: 'Invite 1 Friend',
        invite2: 'Invite 2 Friends',
        invite3: 'Invite 3 Friends',
        members: 'Members',
        rewards: 'Reward Records',
        eventRules: 'Event Rules',
        inviteFriends: 'INVITE FRIENDS',
        joinTeam: 'JOIN THE TEAM',
        enterTeamCode: 'ENTER TEAM INVITE CODE',
        joinNow: 'JOIN NOW',
        copyInfo: 'COPY INVITATION INFO',
        registered: 'Players Registered',
        facebook: 'FOLLOW ON FACEBOOK',
        youtube: 'FOLLOW ON YOUTUBE',
        discord: 'FOLLOW ON DISCORD',
        sharefriend: 'SHARE WITH A FRIEND',
        follow: 'FOLLOW',
        share: 'SHARE',
        name: 'Name',
        enterName: `Please enter the recipient's name`,
        email: 'Email',
        enterEmail: 'Please enter your email',
        phone: 'Phone',
        enterPhone: 'Please enter your contact info',
        address: 'Address',
        enterAddress: `Please enter the recipient's address`,
        submit: 'SUBMIT',
        agree1: 'I agree that Chuang Games will send me the latest game information for "Cross Gate: Adventure" via email',
        agree2_1: `I have read and agree to the `,
        agree2_2: `"Terms of Service" `,
        agree2_3: `and `,
        agree2_4: `"Privacy Policy" `,
        agree2_5: `of Chuang Games`,
        booking_title: 'We will notify you of the latest game information and event updates via email',
        termsOfService: 'Terms of Service',
        privacyPolicy: 'Privacy Policy',
        notice: 'NOTICE',
        news: 'NEWS',
        guides: 'GUIDES',
        return: 'RETURN',
        agreefirst: 'Please check to agree first',
        nodraws: 'Not enough draws',
        validemail: 'Please enter a valid email address',
        validphone: 'Please enter a valid phone number',
        copysuccess: 'Copied successfully',
        logout: 'Log Out',
        copytxt: 'Assemble now and claim exclusive rewards：',
        rule: `
        <p>Event Rules</p>
        <p>1. Event Duration</p>
        <p>From now until 23:59 on the day before the official launch of Cross Gate: Adventure. Please refer to official announcements for exact timings.</p>
        <p></p>
        <p>2. Participants</p>
        <p>All users who complete email pre-registration during the event period are eligible.</p>
        <p></p>
        <p>3. Event Process</p>
        <p>Invite Friends (Inviter)</p>
        <p>(1) Visit the event page: Click the “Invite” button on the homepage; if not logged in, log in with the designated account.</p>
        <p>(2) Copy invitation info: Click the “Copy Invitation Info” button to get your exclusive invite link and team code.</p>
        <p>(3) Share with friends: Share the link/team code via social channels.</p>
        <p>Join Team (Invitee)</p>
        <p>(1) Click invite link: Open the link shared by the inviter to enter the registration page.</p>
        <p>(2) Join team: Click the “Join” button to complete the team-up and check the relevant CDK in Reward Records.</p>
        <p></p>
        <p>4. Rewards</p>
        <p>Invite 1 friend → the whole team receives Magecoins*50000;</p>
        <p>Invite 2 friends → the whole team receives Magecoins*100000;</p>
        <p>Invite 3 friends → the whole team receives Magecoins*200000.</p>
        <p>Reward distribution: Rewards will appear as redemption codes in “Reward Records”. Please redeem within 30 days after launch.</p>
        <p></p>
        <p>5. Notes</p>
        <p>Invitation limit: Each user can invite up to 3 friends.</p>
        <p>Unique team code: Entering the same code multiple times counts only once.</p>
        <p>Privacy compliance: Both parties must agree to the platform’s privacy and email policy.</p>
        <p>Technical issues: If login or copying fails, refresh or switch networks and try again.</p>
        `,
        rule2: `
        <p>1.Pre-registration Period: From now until 23:59 on the day before the launch of Cross Gate: Adventure. Please refer to the official event announcement for the exact date.</p>
        <p>2. Each valid email can only be used to pre-register once. Only players who complete pre-registration during the event period can participate in other related activities.</p>
        <p>3. When the number of pre-registrations reaches milestone targets, the corresponding physical rewards will be distributed server-wide after the open beta.</p>
        <p>4. During the event period, upon reaching both pre-registration and team milestone targets, the corresponding virtual rewards will be sent via in-game mail to the account used for pre-registration within 30 days after the game launches.</p>
        <p>5. Virtual rewards obtained from the lottery will appear as redemption codes in the “Reward Records.” Please redeem them within 30 days after launch. Keep your redemption codes safe; they are for personal use only. Lost or misused codes due to personal reasons will not be reissued.</p>
        <p>6. Physical rewards obtained from the lottery require the recipient’s shipping information to be completed before the end of the event. The official team will confirm details via email or phone before shipment. Incorrect or late information will be considered forfeiture. Physical rewards will be shipped within 90 days after the event ends.</p>
        <p>7. All prizes are non-transferable, non-exchangeable for cash or goods of equal value. Refusal to claim will be considered forfeiture.</p>
        <p>8. Any participant found to have obtained rewards through improper means will be disqualified.</p>
        <p>9. Each account may redeem a maximum of 9 codes obtained from this pre-registration page.</p>
        <p>10. The company reserves the right of final interpretation for all pre-registration activities on this page.</p>
        `,
        congratulations: `Congratulations! You have won a reward. Please check the 'Lottery Records' for your redemption code and redeem it within 1 month after open beta.`,
        job: 'CLASS',
        account: 'Account',
        password: 'Password',
        error_account_or_password: 'Incorrect account/password',
        unfind: 'No top‑up records found',
        close: 'Close',
        contactSupport: 'Contact Support',
        agree3: `I agree that the game server and character information collected and stored for this event will be used only for raffle, claiming, reward delivery, and notifications related to this event.`,
        selectServer: 'Please select a server',
        confirmCharacter: 'Please confirm your character',
        cancel: 'Cancel',
        currentRole: 'Current character for rebate:',
        totalRecharge: 'Total top‑up during test period:',
        rebate: 'Total rebate available: ',
        rebateRule: 'Rebate Rules:',
        isThisRole: 'Confirm to claim the rebate with the currently selected character?',
        receiveSuccess: 'Rewards have been sent to the character’s in‑game mailbox. The mail is valid for 30 days—please log in and claim promptly.',
        rebate_rule1: `
        <p>Event Rules</p>
        <p>1. Top‑up Rebate Rules</p>
        <p>① The player’s total top‑up amount during the test will be rebated according to the rules in the table below.</p>
        `,
        rebate_rule2: `
        <p>Example: A player tops up a total of USD 1000 during the test for in‑game items. At launch, the rebate will be: 300*1.1 + 500*1.05 + 200*1 = 330 + 525 + 200 = 1055</p>
        <p>2. Eligibility</p>
        <p>① Eligible Players: All participants who topped up during this paid test and create a character with the same account in the official launch.</p>
        <p>② Eligible Servers: All servers used in this test.</p>
        <p>Note: This paid test only runs on Google Play. After launch, data will be shared between Google Play and iOS. The platform used for initial character creation does not affect rebate eligibility.</p>
        <p>3. Claim Method</p>
        <p>① After participating, the rebate will be delivered via in‑game mail to the corresponding character. Once the mailbox is enabled, players can receive the rebate mail.</p>
        <p>4. Claim Period</p>
        <p>① Event Start: After the official launch servers open.</p>
        <p>② Event End: Within 90 calendar days from the server launch date.</p>
        <p>③ Mail Validity: After claiming, the rebate mail remains in the mailbox for 30 days. Please claim in time. Expired mail is considered forfeited and cannot be resent.</p>
        <p>5. Notes</p>
        <p>① If a test account has multiple characters across servers, their top‑up totals will be combined for rebate calculation.</p>
        <p>② Rebate Scope: Only direct payments via in‑game shop, recharge center, etc. are counted.</p>
        <p>③ Not Included: Free gifts, event rewards, compensations, quest rewards, first‑top‑up double bonus, or items obtained directly from bundles are excluded.</p>
        <p>④ Eligibility is strictly bound to the test account. Cross‑account claims are not supported.</p>
        <p>⑤ At launch, if multiple characters are created under the same account, the rebate will only be delivered to the selected character’s mailbox. Other characters cannot claim again.</p>
        <p>⑥ The rebate vouchers can be used for all direct‑purchase items in game. Usage follows the rules described in the launch version item descriptions.</p>
        `
    },
    in: {
        ljyy: 'Daftar Sekarang',
        confirm: 'Konfirmasi',
        draw: 'Undian',
        getchance: 'Dapatkan Kesempatan',
        chance: 'Jumlah Undian',
        drawrule: 'Aturan Undian',
        drawrecord: 'Catatan Undian',
        invite1: 'Undang 1 Teman',
        invite2: 'Undang 2 Teman',
        invite3: 'Undang 3 Teman',
        members: 'Jumlah Anggota',
        rewards: 'Catatan Hadiah',
        eventRules: 'Aturan Acara',
        inviteFriends: 'Undang Teman',
        joinTeam: 'Gabung Tim',
        enterTeamCode: 'Masukkan Kode Tim',
        joinNow: 'Gabung Sekarang',
        copyInfo: 'Salin Info Undangan',
        registered: 'Pemain Terdaftar',
        facebook: 'Ikuti Facebook',
        youtube: 'Ikuti YouTube',
        discord: 'Ikuti Discord',
        sharefriend: 'Bagikan ke Teman',
        follow: 'Ikuti',
        share: 'Berbagi',
        name: 'Nama',
        enterName: 'Masukkan nama penerima',
        email: 'Email',
        enterEmail: 'Masukkan alamat email Anda',
        phone: 'Telepon',
        enterPhone: 'Masukkan info kontak Anda',
        address: 'Alamat',
        enterAddress: 'Masukkan alamat penerima',
        submit: 'Kirim',
        agree1: 'Saya setuju menerima info terbaru "Cross Gate: Adventure" dari Chuang Games melalui email',
        agree2_1: `Saya telah membaca dan menyetujui `,
        agree2_2: `"Ketentuan Layanan"`,
        agree2_3: `dan `,
        agree2_4: `"Kebijakan Privasi"`,
        agree2_5: `dari Chuang Games`,
        booking_title: 'Kami akan mengirim info terbaru game & event melalui email',
        termsOfService: 'Ketentuan Layanan',
        privacyPolicy: 'Kebijakan Privasi',
        notice: 'Pengumuman',
        news: 'Berita',
        guides: 'Panduan',
        return: 'Kembali',
        agreefirst: 'Harap centang untuk menyetujui',
        nodraws: 'Jumlah undian tidak cukup',
        validemail: 'Harap masukkan alamat email yang valid',
        validphone: 'Harap masukkan nomor ponsel yang valid',
        copysuccess: 'Berhasil disalin',
        logout: 'Keluar',
        copytxt: 'Segera berkumpul dan klaim hadiah eksklusif：',
        rule: `
        <p>Aturan Acara</p>
        <p>1. Durasi Acara</p>
        <p>Mulai sekarang hingga pukul 23:59 sehari sebelum Cross Gate: Adventure resmi dirilis. Silakan lihat pengumuman resmi untuk detail waktu.</p>
        <p></p>
        <p>2. Peserta</p>
        <p>Semua pengguna yang menyelesaikan pra-registrasi email selama periode acara berhak ikut serta.</p>
        <p></p>
        <p>3. Alur Acara</p>
        <p>Mengundang Teman (Pengundang)</p>
        <p>(1) Kunjungi halaman acara: Klik tombol “Undang” di beranda; jika belum login, masuk dengan akun yang ditentukan.</p>
        <p>(2) Salin info undangan: Klik tombol “Salin Info Undangan” untuk mendapatkan tautan undangan eksklusif dan kode tim.</p>
        <p>(3) Bagikan ke teman: Bagikan tautan/kode tim melalui media sosial.</p>
        <p>Bergabung dengan Tim (Diundang)</p>
        <p>(1) Klik tautan undangan: Buka tautan yang dibagikan pengundang untuk masuk ke halaman pendaftaran.</p>
        <p>(2) Bergabung tim: Klik tombol “Gabung” untuk menyelesaikan tim dan cek CDK di Catatan Hadiah.</p>
        <p></p>
        <p>4. Aturan Hadiah</p>
        <p>Undang 1 teman → seluruh tim mendapat Koin Sihir*50000;</p>
        <p>Undang 2 teman → seluruh tim mendapat Koin Sihir*100000;</p>
        <p>Undang 3 teman → seluruh tim mendapat Koin Sihir*200000.</p>
        <p>Distribusi hadiah: Hadiah muncul sebagai kode penukaran di “Catatan Hadiah”. Tukarkan dalam 30 hari setelah rilis.</p>
        <p></p>
        <p>5. Catatan</p>
        <p>Batas undangan: Maksimal 3 teman per pengguna.</p>
        <p>Kode tim unik: Memasukkan kode yang sama berulang hanya dihitung 1 kali.</p>
        <p>Kepatuhan privasi: Kedua pihak harus menyetujui kebijakan privasi dan email platform.</p>
        <p>Masalah teknis: Jika login atau menyalin gagal, segarkan halaman atau ganti jaringan lalu coba lagi.</p>
        `,
        rule2: `
        <p>1.Periode Pra-registrasi: Berlaku mulai sekarang hingga pukul 23:59 sehari sebelum peluncuran Cross Gate: Adventure. Silakan lihat pengumuman resmi untuk tanggal pastinya.</p>
        <p>2. Setiap email valid hanya dapat digunakan untuk pra-registrasi sekali. Hanya pemain yang menyelesaikan pra-registrasi selama periode acara yang dapat ikut serta dalam aktivitas terkait lainnya.</p>
        <p>3. Jika jumlah pra-registrasi mencapai target tonggak, hadiah fisik yang sesuai akan dibagikan ke seluruh server setelah open beta.</p>
        <p>4. Selama periode acara, setelah mencapai target tonggak pra-registrasi dan tim, hadiah virtual yang sesuai akan dikirim melalui surat dalam game ke akun yang digunakan untuk pra-registrasi dalam waktu 30 hari setelah peluncuran.</p>
        <p>5. Hadiah virtual yang diperoleh dari undian akan muncul sebagai kode penukaran di “Catatan Hadiah.” Harap menukarkannya dalam 30 hari setelah peluncuran. Simpan kode Anda dengan aman; kode hanya untuk penggunaan pribadi. Kehilangan atau penyalahgunaan karena kesalahan pribadi tidak akan diganti.</p>
        <p>6. Hadiah fisik yang diperoleh dari undian memerlukan informasi pengiriman penerima sebelum acara berakhir. Tim resmi akan mengonfirmasi detail melalui email atau telepon sebelum pengiriman. Informasi yang salah atau terlambat dianggap gugur. Hadiah fisik akan dikirim dalam 90 hari setelah acara berakhir.</p>
        <p>7. Semua hadiah tidak dapat dipindahtangankan, ditukar dengan uang tunai, atau barang dengan nilai setara. Penolakan untuk menerima dianggap gugur.</p>
        <p>8. Peserta yang terbukti mendapatkan hadiah dengan cara curang akan didiskualifikasi.</p>
        <p>9. Setiap akun dapat menukarkan maksimal 9 kode yang diperoleh dari halaman pra-registrasi ini.</p>
        <p>10. Perusahaan memiliki hak interpretasi akhir untuk semua aktivitas pra-registrasi di halaman ini.</p>
        `,
        congratulations: `Selamat! Anda telah memenangkan hadiah. Silakan cek 'Catatan Undian' untuk kode penukaran dan tukarkan dalam waktu 1 bulan setelah open beta.`,
        job: 'Kelas',
        account: 'Akun',
        password: 'Kata Sandi',
        error_account_or_password: 'Akun/Kata sandi salah',
        unfind: 'Tidak ada catatan top‑up',
        close: 'Tutup',
        contactSupport: 'Hubungi Layanan Pelanggan',
        agree3: `Saya setuju bahwa informasi server game dan karakter yang dikumpulkan serta disimpan untuk acara ini hanya akan digunakan untuk undian, klaim hadiah, pengiriman hadiah, dan pemberitahuan terkait acara ini.`,
        selectServer: 'Silakan pilih server',
        confirmCharacter: 'Harap konfirmasi karakter',
        cancel: 'Batal',
        currentRole: 'Karakter yang mengikuti rebat saat ini:',
        totalRecharge: 'Total top‑up selama periode uji:',
        rebate: 'Total rebat yang tersedia: ',
        rebateRule: 'Aturan Rebat:',
        isThisRole: 'Konfirmasi klaim rebat dengan karakter yang dipilih saat ini?',
        receiveSuccess: 'Hadiah telah dikirim ke kotak surat dalam game karakter. Surat berlaku 30 hari—harap login dan klaim segera.',
        rebate_rule1: `
        <p>Aturan Acara</p>
        <p>1. Aturan Rebat Top‑up</p>
        <p>① Total top‑up pemain selama periode uji akan diberi rebat sesuai aturan pada tabel berikut.</p>
        `,
        rebate_rule2: `
        <p>Contoh: Pemain melakukan top‑up total USD 1000 selama periode uji untuk item dalam game. Saat rilis, rebatnya: 300*1.1 + 500*1.05 + 200*1 = 330 + 525 + 200 = 1055</p>
        <p>2. Penerima</p>
        <p>① Penerima: Semua pemain yang mengikuti uji coba berbayar ini dan melakukan top‑up, lalu membuat karakter dengan akun yang sama saat rilis resmi.</p>
        <p>② Server: Semua server yang digunakan dalam uji coba ini.</p>
        <p>Catatan: Uji coba berbayar ini hanya tersedia di Google Play. Setelah rilis, data akan dibagikan antara Google Play dan iOS. Platform saat membuat karakter pertama tidak memengaruhi kelayakan rebat.</p>
        <p>3. Cara Klaim</p>
        <p>① Setelah berpartisipasi, rebat akan dikirim melalui surat dalam game ke karakter terkait. Setelah kotak surat diaktifkan, pemain dapat menerima surat rebat.</p>
        <p>4. Periode Klaim</p>
        <p>① Mulai Acara: Setelah server rilis resmi dibuka.</p>
        <p>② Berakhir: Dalam 90 hari kalender sejak server resmi dibuka.</p>
        <p>③ Validitas Surat: Setelah diklaim, surat rebat tetap ada di kotak masuk selama 30 hari. Harap klaim tepat waktu. Surat yang kedaluwarsa dianggap hangus dan tidak dapat dikirim ulang.</p>
        <p>5. Catatan</p>
        <p>① Jika akun uji memiliki beberapa karakter di berbagai server, total top‑up digabung untuk perhitungan rebat.</p>
        <p>② Cakupan Rebat: Hanya pembayaran langsung melalui toko dalam game, pusat top‑up, dll yang dihitung.</p>
        <p>③ Tidak Termasuk: Hadiah gratis, hadiah event, kompensasi, hadiah quest, bonus top‑up pertama dua kali lipat, atau item dari bundel tidak dihitung.</p>
        <p>④ Kelayakan terikat pada akun uji. Klaim lintas akun tidak didukung.</p>
        <p>⑤ Saat rilis, jika satu akun membuat beberapa karakter, rebat hanya dikirim ke kotak surat karakter yang dipilih. Karakter lain tidak bisa klaim ulang.</p>
        <p>⑥ Voucher rebat dapat digunakan untuk semua item pembelian langsung dalam game. Aturan penggunaan mengikuti deskripsi item pada versi rilis.</p>
        `
    },
    th: {
        ljyy: 'จองเลย',
        confirm: 'ยืนยัน',
        draw: 'จับสลาก',
        getchance: 'รับสิทธิ์ลุ้น',
        chance: 'จำนวนครั้งการจับสลาก',
        drawrule: 'กติกาการจับสลาก',
        drawrecord: 'ประวัติการจับสลาก',
        invite1: 'เชิญเพื่อน 1 คน',
        invite2: 'เชิญเพื่อน 2 คน',
        invite3: 'เชิญเพื่อน 3 คน',
        members: 'จำนวนสมาชิก',
        rewards: 'ประวัติรางวัล',
        eventRules: 'กติกากิจกรรม',
        inviteFriends: 'เชิญเพื่อน',
        joinTeam: 'เข้าร่วมทีม',
        enterTeamCode: 'กรุณากรอกรหัสทีม',
        joinNow: 'เข้าร่วมทันที',
        copyInfo: `คัดลอกข้อมูลเชิญ`,
        registered: 'ผู้เล่นที่ลงทะเบียนแล้ว',
        facebook: 'ติดตาม Facebook',
        youtube: 'ติดตาม YouTube',
        discord: 'ติดตาม Discord',
        sharefriend: 'แชร์ให้เพื่อน',
        follow: 'ติดตาม',
        share: 'แบ่งปัน',
        name: 'ชื่อ',
        enterName: 'กรุณากรอกชื่อผู้รับ',
        email: 'อีเมล',
        enterEmail: 'กรุณากรอกอีเมล',
        phone: 'หมายเลข',
        enterPhone: 'กรุณากรอกข้อมูลติดต่อ',
        address: 'ที่อยู่',
        enterAddress: 'กรุณากรอกที่อยู่ผู้รับ',
        submit: 'ส่ง',
        agree1: 'ฉันยอมรับให้ Chuang Games ส่งข้อมูลเกมล่าสุดของ "Cross Gate: Adventure" ผ่านอีเมล',
        agree2_1: `ฉันได้อ่านและยอมรับ `,
        agree2_2: `"ข้อกำหนดการให้บริการ" `,
        agree2_3: `และ `,
        agree2_4: `"นโยบายความเป็นส่วนตัว" `,
        agree2_5: `ของ Chuang Games`,
        booking_title: 'เราจะแจ้งข้อมูลเกมและกิจกรรมล่าสุดให้คุณทางอีเมล',
        termsOfService: 'ข้อกำหนดการให้บริการ',
        privacyPolicy: 'นโยบายความเป็นส่วนตัว',
        notice: 'ประกาศ',
        news: 'ข่าว',
        guides: 'คู่มือ',
        return: `กลับ`,
        agreefirst: 'โปรดทำเครื่องหมายยืนยันก่อน',
        nodraws: 'สิทธิ์จับสลากไม่พอ',
        validemail: 'กรุณากรอกอีเมลที่ถูกต้อง',
        validphone: 'กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง',
        copysuccess: 'คัดลอกสำเร็จ',
        logout: 'ออกจากระบบ',
        copytxt: 'รวมพลทันที รับรางวัลพิเศษ：',
        rule: `
        <p>กติกากิจกรรม</p>
        <p>1. ระยะเวลากิจกรรม</p>
        <p>ตั้งแต่วันนี้จนถึงเวลา 23:59 ของวันก่อนที่ Cross Gate: Adventure จะเปิดให้บริการ โปรดติดตามประกาศอย่างเป็นทางการสำหรับเวลาที่แน่นอน</p>
        <p></p>
        <p>2. ผู้เข้าร่วม</p>
        <p>ผู้ใช้ทุกคนที่ทำการลงทะเบียนล่วงหน้าด้วยอีเมลในช่วงเวลากิจกรรมสามารถเข้าร่วมได้</p>
        <p></p>
        <p>3. ขั้นตอนกิจกรรม</p>
        <p>เชิญเพื่อน (ผู้เชิญ)</p>
        <p>(1) เข้าหน้ากิจกรรม: คลิกปุ่ม “เชิญ” บนหน้าแรก หากยังไม่ได้เข้าสู่ระบบ ให้เข้าสู่ระบบด้วยบัญชีที่กำหนด</p>
        <p>(2) คัดลอกข้อมูลเชิญ: คลิกปุ่ม “คัดลอกข้อมูลเชิญ” เพื่อรับลิงก์เชิญพิเศษและรหัสทีม</p>
        <p>(3) แชร์ให้เพื่อน: แชร์ลิงก์/รหัสทีมผ่านช่องทางโซเชียล</p>
        <p>เข้าร่วมทีม (ผู้ถูกเชิญ)</p>
        <p>(1) คลิกลิงก์เชิญ: เปิดลิงก์ที่ผู้เชิญแชร์ เพื่อเข้าสู่หน้าลงทะเบียน</p>
        <p>(2) เข้าร่วมทีม: คลิกปุ่ม “เข้าร่วม” เพื่อเสร็จสิ้นการรวมทีม และตรวจสอบ CDK ในบันทึกรางวัล</p>
        <p></p>
        <p>4. กติกาของรางวัล</p>
        <p>เชิญเพื่อน 1 คน → ทีมได้รับ เหรียญเวท*50000;</p>
        <p>เชิญเพื่อน 2 คน → ทีมได้รับ เหรียญเวท*100000;</p>
        <p>เชิญเพื่อน 3 คน → ทีมได้รับ เหรียญเวท*200000.</p>
        <p>การส่งมอบรางวัล: รางวัลจะปรากฏเป็นรหัสแลกเปลี่ยนใน “บันทึกรางวัล” กรุณาแลกภายใน 30 วันหลังเกมเปิด</p>
        <p></p>
        <p>5. หมายเหตุ</p>
        <p>จำกัดการเชิญ: เชิญได้สูงสุด 3 คนต่อผู้ใช้</p>
        <p>รหัสทีมไม่ซ้ำ: การใส่รหัสทีมซ้ำจะนับเพียงครั้งเดียว</p>
        <p>ความเป็นส่วนตัว: ทั้งสองฝ่ายต้องยอมรับนโยบายความเป็นส่วนตัวและข้อตกลงอีเมล</p>
        <p>ปัญหาทางเทคนิค: หากเข้าสู่ระบบหรือคัดลอกไม่สำเร็จ ให้รีเฟรชหรือเปลี่ยนเครือข่ายแล้วลองอีกครั้ง</p>
        `,
        rule2: `
        <p>1.ระยะเวลาการจองล่วงหน้า: ตั้งแต่วันนี้จนถึงเวลา 23:59 ของวันก่อนการเปิดตัว Cross Gate: Adventure โปรดดูประกาศกิจกรรมอย่างเป็นทางการสำหรับวันที่แน่นอน</p>
        <p>2. อีเมลที่ถูกต้องแต่ละอันสามารถใช้จองล่วงหน้าได้เพียงครั้งเดียวเท่านั้น ผู้เล่นที่ทำการจองล่วงหน้าภายในระยะเวลากิจกรรมจะสามารถเข้าร่วมกิจกรรมอื่นๆ ที่เกี่ยวข้องได้</p>
        <p>3. เมื่อจำนวนการจองล่วงหน้าถึงเป้าหมายที่กำหนด รางวัลจริงที่สอดคล้องจะถูกแจกให้ทั้งเซิร์ฟเวอร์หลังจากการทดสอบแบบเปิด (open beta)</p>
        <p> 4. ในช่วงเวลากิจกรรม เมื่อบรรลุเป้าหมายทั้งการจองล่วงหน้าและการรวมทีม รางวัลเสมือนที่สอดคล้องจะถูกส่งทางจดหมายในเกมไปยังบัญชีที่ใช้จองล่วงหน้าภายใน 30 วันหลังจากเกมเปิดตัว</p>
        <p>5. รางวัลเสมือนที่ได้รับจากการจับสลากจะปรากฏเป็นรหัสแลกใน “บันทึกรางวัล” กรุณาแลกภายใน 30 วันหลังจากเปิดตัวเกม เก็บรหัสของคุณให้ปลอดภัย รหัสใช้ได้เฉพาะบุคคล หากสูญหายหรือใช้ผิดพลาดจะไม่สามารถออกใหม่ได้</p>
        <p>6. รางวัลจริงที่ได้รับจากการจับสลากต้องกรอกข้อมูลการจัดส่งก่อนสิ้นสุดกิจกรรม ทีมงานจะติดต่อยืนยันข้อมูลผ่านอีเมลหรือโทรศัพท์ก่อนจัดส่ง หากข้อมูลไม่ถูกต้องหรือส่งช้าจะถือว่าสละสิทธิ์ รางวัลจริงจะถูกจัดส่งภายใน 90 วันหลังจากกิจกรรมสิ้นสุด</p>
        <p>7. รางวัลทั้งหมดไม่สามารถโอนสิทธิ์ แลกเป็นเงินสด หรือสินค้าอื่นที่มีมูลค่าเท่ากันได้ การปฏิเสธรับถือว่าสละสิทธิ์</p>
        <p>8. หากพบว่าผู้เข้าร่วมได้รับรางวัลด้วยวิธีการทุจริตจะถูกตัดสิทธิ์</p>
        <p>9. บัญชีแต่ละบัญชีสามารถแลกรหัสได้สูงสุด 9 ครั้งจากหน้านี้</p>
        <p>10. บริษัทขอสงวนสิทธิ์ในการตีความขั้นสุดท้ายสำหรับกิจกรรมจองล่วงหน้าทั้งหมดในหน้านี้</p>
        `,
        congratulations: `ยินดีด้วย! คุณได้รับรางวัล กรุณาตรวจสอบ 'ประวัติการจับสลาก' เพื่อรับรหัสแลกรางวัล และแลกภายใน 1 เดือนหลังจาก open beta`,
        job: 'อาชีพ',
        account: 'บัญชี',
        password: 'รหัสผ่าน',
        error_account_or_password: 'บัญชี/รหัสผ่านไม่ถูกต้อง',
        unfind: 'ไม่พบประวัติการเติมเงิน',
        close: 'ปิด',
        contactSupport: 'ติดต่อฝ่ายบริการลูกค้า',
        agree3: `ข้าพเจ้ายินยอมให้ข้อมูลเซิร์ฟเวอร์และตัวละครที่เก็บและจัดเก็บเพื่อกิจกรรมนี้ ถูกใช้เฉพาะสำหรับการสุ่มจับรางวัล การรับของรางวัล การมอบรางวัล และการแจ้งเตือนของกิจกรรมนี้เท่านั้น`,
        selectServer: 'โปรดเลือกเซิร์ฟเวอร์',
        confirmCharacter: 'โปรดยืนยันตัวละคร',
        cancel: 'ยกเลิก',
        currentRole: 'ตัวละครที่เข้าร่วมเงินคืนปัจจุบัน: ',
        totalRecharge: 'ยอดเติมรวมช่วงทดสอบ:',
        rebate: 'ยอดเงินคืนที่ได้รับทั้งหมด:',
        rebateRule: 'กติกาเงินคืน:',
        isThisRole: 'ยืนยันรับเงินคืนด้วยตัวละครที่เลือกปัจจุบันหรือไม่?',
        receiveSuccess: 'รางวัลถูกส่งไปยังกล่องจดหมายในเกมของตัวละครแล้ว จดหมายมีอายุ 30 วัน—โปรดเข้าสู่ระบบและรับให้เร็วที่สุด',
        rebate_rule1: `
        <p>กติกากิจกรรม</p>
        <p>1. กติกาการคืนเงินจากการเติม</p>
        <p>① ยอดเติมรวมของผู้เล่นในช่วงทดสอบจะได้รับเงินคืนตามกฎในตารางด้านล่าง</p>
        `,
        rebate_rule2: `
        <p>ตัวอย่าง: ผู้เล่นเติมเงินรวม USD 1000 ระหว่างทดสอบเพื่อซื้อไอเท็มในเกม ช่วงเปิดจริงจะได้รับเงินคืน: 300*1.1 + 500*1.05 + 200*1 = 330 + 525 + 200 = 1055</p>
        <p>2. ผู้มีสิทธิ์</p>
        <p>① ผู้มีสิทธิ์: ผู้เล่นทุกคนที่เข้าร่วมการทดสอบแบบมีค่าใช้จ่ายนี้และเติมเงิน และสร้างตัวละครด้วยบัญชีเดียวกันในช่วงเปิดจริง</p>
        <p>② เซิร์ฟเวอร์: ทุกเซิร์ฟเวอร์ที่ใช้ในการทดสอบนี้</p>
        <p>หมายเหตุ: การทดสอบแบบเสียเงินนี้มีเฉพาะบน Google Play หลังจากเปิดจริง ข้อมูลจะเชื่อมระหว่าง Google Play และ iOS แพลตฟอร์มที่ใช้สร้างตัวละครครั้งแรกไม่กระทบสิทธิ์การคืนเงิน</p>
        <p>3. วิธีรับ</p>
        <p>① หลังจากเข้าร่วมกิจกรรม เงินคืนจะถูกส่งผ่านจดหมายในเกมไปยังตัวละครที่เกี่ยวข้อง เมื่อเปิดกล่องจดหมายแล้ว ผู้เล่นจะได้รับจดหมายคืนเงิน</p>
        <p>4. ระยะเวลารับ</p>
        <p>① เริ่มกิจกรรม: หลังจากเซิร์ฟเวอร์เปิดจริง</p>
        <p>② สิ้นสุดกิจกรรม: ภายใน 90 วันปฏิทินนับจากวันที่เซิร์ฟเวอร์เปิดจริง</p>
        <p>③ อายุจดหมาย: หลังจากรับ จดหมายคืนเงินจะอยู่ในกล่องจดหมาย 30 วัน โปรดรับให้ทันเวลา หากหมดอายุจะถือว่าสละสิทธิ์และไม่สามารถส่งซ้ำได้</p>
        <p>5. ข้อควรระวัง</p>
        <p>① หากบัญชีทดสอบมีหลายตัวละครในหลายเซิร์ฟเวอร์ ยอดเติมทั้งหมดจะถูกรวมเพื่อคำนวณเงินคืน</p>
        <p>② ขอบเขตการคืนเงิน: นับเฉพาะการจ่ายโดยตรงผ่านร้านค้าในเกม ศูนย์เติมเงิน ฯลฯ</p>
        <p>③ ไม่รวม: ของฟรี รางวัลกิจกรรม ชดเชย รางวัลภารกิจ โบนัสเติมครั้งแรกสองเท่า หรือไอเท็มจากแพ็กเกจจะไม่ถูกรวม</p>
        <p>④ สิทธิ์การคืนเงินผูกกับบัญชีทดสอบ ไม่สนับสนุนการข้ามบัญชี</p>
        <p>⑤ ช่วงเปิดจริง หากมีหลายตัวละครภายใต้บัญชีเดียว เงินคืนจะถูกส่งไปยังกล่องจดหมายของตัวละครที่เลือกเท่านั้น ตัวละครอื่นไม่สามารถรับซ้ำได้</p>
        <p>⑥ คูปองคืนเงินใช้ได้กับทุกไอเท็มที่ซื้อโดยตรงในเกม กฎการใช้งานตามคำอธิบายไอเท็มในเวอร์ชันเปิดจริง</p>
        `,
    },
    fi: {
        ljyy: 'Magparehistro Ngayon',
        confirm: 'Kumpirmahin',
        draw: 'Raffle',
        getchance: 'Kumuha ng mga tsansa',
        chance: 'Bilang ng raffle',
        drawrule: 'Patakaran',
        drawrecord: 'Talaan ng Raffle',
        invite1: 'Mag-imbita ng 1 Kaibigan',
        invite2: 'Mag-imbita ng 2 Kaibigan',
        invite3: 'Mag-imbita ng 3 Kaibigan',
        members: 'Bilang ng Miyembro',
        rewards: 'Talaan ng Gantimpala',
        eventRules: 'Mga Panuntunan ng Kaganapan',
        inviteFriends: 'Mag-imbita ng Kaibigan',
        joinTeam: 'Sumali sa Grupo',
        enterTeamCode: 'Ipasok ang Code ng Imbitasyon ng Grupo',
        joinNow: 'Sumali Ngayon',
        copyInfo: 'Kopyahin ang Impormasyon ng Imbitasyon',
        registered: 'Mga Manlalarong Nakarehistro',
        facebook: 'Sundan ang Facebook',
        youtube: 'Sundan ang YouTube',
        discord: 'Sundan ang Discord',
        sharefriend: 'Ibahagi sa Kaibigan',
        follow: 'Sundan',
        share: 'share',
        name: 'Pangalan',
        enterName: 'Pakilagay ang pangalan ng tatanggap',
        email: 'Email',
        enterEmail: 'Pakilagay ang email mo',
        phone: 'Telepono',
        enterPhone: 'Pakilagay ang iyong impormasyon sa pakikipag-ugnayan',
        address: 'Address',
        enterAddress: 'Pakilagay ang address ng tatanggap',
        submit: 'Isumite',
        agree1: 'Sumasang-ayon ako na padalhan ako ng Chuang Games ng pinakabagong impormasyon tungkol sa "Cross Gate: Adventure" sa pamamagitan ng email',
        agree2_1: `Nabasa ko at sumasang-ayon ako sa `,
        agree2_2: `"Mga Tuntunin ng Serbisyo" `,
        agree2_3: `at `,
        agree2_4: `"Patakaran sa Privacy" `,
        agree2_5: `ng Chuang Games`,
        booking_title: 'Magpapadala kami ng pinakabagong balita at update ng laro at event sa iyong email',
        termsOfService: 'Mga Tuntunin ng Serbisyo',
        privacyPolicy: 'Patakaran sa Privacy',
        notice: 'Mga Anunsyo',
        news: 'Balita',
        guides: 'Mga Gabay',
        return: `Bumalik`,
        agreefirst: 'Pakitsek muna para sumang-ayon',
        nodraws: 'Kulang ang bilang ng raffle draws',
        validemail: 'Pakilagay ang wastong email address',
        validphone: 'Pakilagay ang wastong numero ng telepono',
        copysuccess: 'Matagumpay na nakopya',
        logout: 'Mag-logout',
        copytxt: 'Magtipon ngayon at kunin ang eksklusibong gantimpala：',
        rule: `
        <p>Mga Panuntunan ng Kaganapan</p>
        <p>1. Tagal ng Kaganapan</p>
        <p>Mula ngayon hanggang 23:59 ng araw bago ang opisyal na paglulunsad ng Cross Gate: Adventure. Sumangguni sa opisyal na anunsyo para sa eksaktong oras.</p>
        <p></p>
        <p>2. Mga Kalahok</p>
        <p>Lahat ng gumagamit na nakatapos ng email pre-registration sa panahon ng event ay maaaring lumahok.</p>
        <p></p>
        <p>3. Proseso ng Event</p>
        <p>Pag-imbita ng Kaibigan (Nag-imbita)</p>
        <p>(1) Buksan ang event page: I-click ang “Imbitahin” button sa homepage; kung hindi naka-login, mag-login gamit ang nakatalagang account.</p>
        <p>(2) Kopyahin ang info ng imbitasyon: I-click ang “Kopyahin ang Info ng Imbitasyon” upang makuha ang eksklusibong link at team code.</p>
        <p>(3) Ibahagi sa kaibigan: Ibahagi ang link/team code sa social channels.</p>
        <p>Sumali sa Team (Inimbitahan)</p>
        <p>(1) I-click ang link ng imbitasyon: Buksan ang link na ibinahagi ng nag-imbita upang pumasok sa page ng pre-registration.</p>
        <p>(2) Sumali sa team: I-click ang “Sumali” button upang makumpleto ang team at tingnan ang CDK sa Reward Records.</p>
        <p></p>
        <p>4. Mga Gantimpala</p>
        <p>Mag-imbita ng 1 kaibigan → buong team ay makakakuha ng Magecoins*50000;</p>
        <p>Mag-imbita ng 2 kaibigan → buong team ay makakakuha ng Magecoins*100000;</p>
        <p>Mag-imbita ng 3 kaibigan → buong team ay makakakuha ng Magecoins*200000.</p>
        <p>Pagbigay ng gantimpala: Ang gantimpala ay makikita bilang redemption code sa “Reward Records”. I-redeem sa loob ng 30 araw matapos ang launch.</p>
        <p></p>
        <p>5. Paalala</p>
        <p>Limitasyon ng imbitasyon: Max 3 kaibigan bawat user.</p>
        <p>Natatanging team code: Ang pag-ulit ng parehong code ay bilang 1 lamang.</p>
        <p>Privacy compliance: Dapat sumang-ayon ang parehong panig sa privacy at email policy ng platform.</p>
        <p>Problema sa teknikal: Kung nabigo ang login o copy, i-refresh o palitan ang network at subukan muli.</p>
        `,
        rule2: `
        <p>1.Panahon ng Pre-registration: Mula ngayon hanggang 23:59 sa araw bago ang paglulunsad ng Cross Gate: Adventure. Sumangguni sa opisyal na anunsyo para sa eksaktong petsa.</p>
        <p>2. Isang beses lang maaaring gamitin ang bawat valid na email para mag-pre-register. Tanging mga manlalarong nag-complete ng pre-registration sa panahon ng event ang maaaring sumali sa iba pang kaugnay na aktibidad.</p>
        <p>3. Kapag naabot ang target na bilang ng pre-registration, ipapamahagi ang katumbas na pisikal na premyo sa buong server pagkatapos ng open beta.</p>
        <p>4. Sa panahon ng event, kapag naabot ang parehong pre-registration at team milestone targets, ang katumbas na virtual na gantimpala ay ipapadala sa pamamagitan ng in-game mail sa account na ginamit sa pre-registration sa loob ng 30 araw matapos ilunsad ang laro.</p>
        <p>5. Ang mga virtual na gantimpala mula sa raffle ay lilitaw bilang redemption code sa “Talaan ng Gantimpala.” I-redeem ito sa loob ng 30 araw matapos ang paglulunsad. Itago nang maayos ang iyong code; personal use lamang ito at hindi papalitan kung mawala o magamit nang mali.</p>
        <p>6. Ang mga pisikal na premyo mula sa raffle ay nangangailangan ng kumpletong impormasyon sa pagpapadala bago matapos ang event. Kumpirmahin ng opisyal na team sa pamamagitan ng email o telepono bago ipadala. Ang maling o huling impormasyon ay ituturing na pagbitiw sa karapatan. Ipapaabot ang mga pisikal na premyo sa loob ng 90 araw matapos ang pagtatapos ng event.</p>
        <p>7. Ang lahat ng premyo ay hindi maililipat, hindi maaaring ipalit sa pera o katumbas na halaga. Ang pagtanggi ay ituturing na pagbitiw sa karapatan.</p>
        <p>8. Ang sinumang mapatunayang nandaya para makakuha ng premyo ay madidiskwalipika.</p>
        <p>9. Maaaring mag-redeem ang bawat account ng maximum na 9 na code mula sa pre-registration page na ito.</p>
        <p>10. Nakalaan sa kumpanya ang huling interpretasyon para sa lahat ng aktibidad sa pre-registration sa page na ito.</p>
        `,
        congratulations: `Congrats! Nanalo ka ng gantimpala. Tingnan sa 'Talaan ng Raffle' ang iyong code at i-redeem ito sa loob ng 1 buwan matapos ang open beta.`,
        job: 'Klase',
        account: 'Account',
        password: 'Password',
        error_account_or_password: 'Mali ang account/password',
        unfind: 'Walang nakitang tala ng top‑up',
        close: 'Isara',
        contactSupport: 'Makipag‑ugnayan sa Suporta',
        agree3: `Sumasang‑ayon ako na ang impormasyon ng server at karakter na nakolekta at iniimbak para sa event na ito ay gagamitin lamang para sa raffle, pag‑claim, pagpapadala ng gantimpala, at mga abiso kaugnay ng event na ito.`,
        selectServer: 'Pumili ng server',
        confirmCharacter: 'Pakitiyak ang iyong karakter',
        cancel: 'Kanselahin',
        currentRole: 'Kasalukuyang karakter para sa rebate: ',
        totalRecharge: 'Kabuuang top‑up sa panahon ng test: ',
        rebate: 'Kabuuang rebate na makukuha: ',
        rebateRule: 'Mga Panuntunan sa Rebate:',
        isThisRole: 'Kumpirmahin na i‑claim ang rebate gamit ang kasalukuyang napiling karakter?',
        receiveSuccess: 'Naipadala na ang mga gantimpala sa in‑game mailbox ng karakter. May bisa ang liham sa loob ng 30 araw—mag‑login at i‑claim agad.',
        rebate_rule1: `
        <p>Mga Panuntunan ng Kaganapan</p>
        <p>1. Mga Panuntunan sa Rebate ng Top‑up</p>
        <p>① Ang kabuuang top‑up ng manlalaro sa panahon ng test ay ibabalik ayon sa mga tuntunin sa talahanayan sa ibaba.</p>
        `,
        rebate_rule2: `
        <p>Halimbawa: Nag‑top up ang manlalaro ng kabuuang USD 1000 sa panahon ng test para sa mga item sa laro. Sa launch, ang rebate ay: 300*1.1 + 500*1.05 + 200*1 = 330 + 525 + 200 = 1055</p>
        <p>2. Mga Karapat‑dapat</p>
        <p>① Karapat‑dapat: Lahat ng lumahok sa paid test na ito at nag‑top up, at gagamit ng parehong account upang gumawa ng karakter sa opisyal na launch.</p>
        <p>② Mga Server: Lahat ng server na ginamit sa test na ito.</p>
        <p>Tala: Ang paid test na ito ay nasa Google Play lamang. Pagkatapos ng launch, magbabahagi ng data ang Google Play at iOS. Ang platform na ginamit sa unang paggawa ng karakter ay hindi nakakaapekto sa rebate eligibility.</p>
        <p>3. Paraan ng Pag‑claim</p>
        <p>① Pagkatapos lumahok, ipapadala ang rebate sa pamamagitan ng in‑game mail sa kaukulang karakter. Kapag naka‑enable na ang mailbox, matatanggap ng manlalaro ang rebate mail.</p>
        <p>4. Panahon ng Pag‑claim</p>
        <p>① Pagsisimula ng Event: Pagkatapos bumukas ang opisyal na launch servers.</p>
        <p>② Katapusan: Sa loob ng 90 araw mula sa petsa ng server launch.</p>
        <p>③ Bisa ng Mail: Pagkatapos ma‑claim, mananatili ang rebate mail sa mailbox nang 30 araw. Kailangan itong i‑claim agad. Ang nag‑expire ay ituturing na tinanggihan at hindi na maipapadala muli.</p>
        <p>5. Mga Paalala</p>
        <p>① Kung ang isang test account ay may maraming karakter sa iba’t ibang server, pagsasamahin ang kanilang top‑up totals para sa kalkulasyon ng rebate.</p>
        <p>② Saklaw ng Rebate: Tanging direktang bayad sa in‑game shop, recharge center, atbp. ang binibilang.</p>
        <p>③ Hindi Kasama: Libreng regalo, gantimpala sa event, kompensasyon, gantimpala mula sa quest, dobleng bonus ng unang top‑up, o mga item mula sa bundle ay hindi isinasama.</p>
        <p>④ Ang rebate eligibility ay nakatali lamang sa test account. Hindi sinusuportahan ang cross‑account claim.</p>
        <p>⑤ Sa launch, kung maraming karakter sa parehong account, sa napiling karakter lang ipapadala ang rebate. Hindi ito pwedeng ulitin ng ibang karakter.</p>
        <p>⑥ Ang rebate vouchers ay magagamit para sa lahat ng direktang bili na item sa laro. Ang paggamit ay ayon sa patakaran sa paglalarawan ng item sa launch version.</p>
        `,
    },
}
// 获取当前语言的文本
function i18n(key) {
    const currentLanguage = store.getters.language || 'zh'; // 默认中文
    return i18nText[currentLanguage] && i18nText[currentLanguage][key] 
           ? i18nText[currentLanguage][key] 
           : i18nText['zh'][key]; // 找不到时回退到中文
}

// 获取指定语言的文本
function i18nByLang(lang, key) {
    return i18nText[lang] && i18nText[lang][key] 
           ? i18nText[lang][key] 
           : i18nText['zh'][key];
}

// 获取当前语言的所有文本
function getCurrentLangTexts() {
    const currentLanguage = store.getters.language || 'zh';
    return i18nText[currentLanguage] || i18nText['zh'];
}

export default i18n
export { i18nByLang, getCurrentLangTexts }